import * as React from "react";
const SvgFiRrLaughBeam = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-laugh-beam_svg__a)">
      <path
        fill="#062147"
        d="M7 11a1 1 0 1 1-2 0c0-1.892 1.232-4 3-4s3 2.108 3 4a1 1 0 1 1-2 0c0-1.054-.68-2-1-2-.321 0-1 .946-1 2m9-4c-1.768 0-3 2.108-3 4a1 1 0 0 0 2 0c0-1.054.678-2 1-2 .32 0 1 .946 1 2a1 1 0 0 0 2 0c0-1.892-1.233-4-3-4m-.01 7H8.009a.994.994 0 0 0-.955 1.3 5.178 5.178 0 0 0 9.9-.007.995.995 0 0 0-.965-1.293M24 12a12.013 12.013 0 0 1-12 12C-3.9 23.4-3.894.6 12 0a12.013 12.013 0 0 1 12 12m-2 0A10.01 10.01 0 0 0 12 2c-13.248.5-13.245 19.5 0 20a10.01 10.01 0 0 0 10-10"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-laugh-beam_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrLaughBeam;
